import { Link } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function RevenueBrandBar() {
  const { resolvedTheme, toggleTheme } = useTheme();
  return <nav className="revenue-brandbar" aria-label="NTP Tourism">
    <Link className="revenue-brand" to="/"><span>NTP</span>Tourism &amp; journeys</Link>
    <button className="revenue-theme-toggle" type="button" onClick={toggleTheme} aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} mode`}>
      {resolvedTheme === 'dark' ? <Sun size={15} aria-hidden="true" /> : <Moon size={15} aria-hidden="true" />}
      {resolvedTheme === 'dark' ? 'Light mode' : 'Dark mode'}
    </button>
  </nav>;
}
